import { render } from "./Whatsapp.vue?vue&type=template&id=750b4b82&scoped=true"
import script from "./Whatsapp.vue?vue&type=script&lang=js"
export * from "./Whatsapp.vue?vue&type=script&lang=js"

import "./Whatsapp.vue?vue&type=style&index=0&id=750b4b82&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/goldenaces-club/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-750b4b82"]])

export default __exports__